import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EpcotConfig, MyBetsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup } from '@frontend/sports/common/core/utils/hooks';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';
import { UserService } from '@frontend/sports/user/feature';
import { HtmlNode } from '@frontend/vanilla/core';

import { MyBetsListContext, MyBetsSlipEditBetHistoryViewModel } from '../../../my-bets-base/models/my-bets-viewmodels';
import { PrintPageBaseComponent } from '../../../print/print-base-page.component';
import { PrintDeviceType } from '../../../print/print.models';
import { MyBetsUtilService } from '../../services/my-bets-util.service';

@HooksWireup()
@Component({
    selector: 'ms-my-bets-print-edit-bet-history',
    templateUrl: './my-bets-print-edit-bet-history.html',
})
export class MyBetsPrintEditBetHistoryComponent extends PrintPageBaseComponent<MyBetsSlipEditBetHistoryViewModel[]> {
    betslips: MyBetsSlipEditBetHistoryViewModel[];
    myBetsListContext = new MyBetsListContext();
    userID: string | null;
    UserName: string | null;
    isEpcotEnabled = false;

    @HostBinding('class') className = 'print-edit-bet-history';

    constructor(
        route: ActivatedRoute,
        htmlNodeService: HtmlNode,
        public sitecore: Sitecore,
        private userService: UserService,
        private epcotConfig: EpcotConfig,
        private myBetsUtilService: MyBetsUtilService,
        timer: TimerService,
        private mybetsConfig: MyBetsConfig,
    ) {
        super(route, htmlNodeService, timer);
        this.userID = this.userService.accountId;
        this.UserName = this.userService.username;
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    onRouteResolved(betslips: MyBetsSlipEditBetHistoryViewModel[]): void {
        this.myBetsListContext.listType = BetslipListType.Settled;
        this.myBetsListContext.isPrintView = true;

        if (this.printCommand !== PrintDeviceType.Default) {
            this.betslips = this.betslips.slice(0, this.mybetsConfig.printBetsThresholdForApp);
        } else {
            this.betslips = betslips;
        }

        this.myBetsUtilService.setPrintState(true);
    }
}
